import React from 'react'
import PropTypes from 'prop-types'
import useSmartviewMounter from '../hooks/use-smartview-mounter'
import { useModel, ModelContext } from '@morningtrain/react-resources'

function MountSmartviewWithModel (props) {
  const model = useModel()

  const smartview = (
    <ModelContext.Provider value={props.model || model}>
      {props.smartview}
    </ModelContext.Provider>
  )

  const mount = useSmartviewMounter(smartview, props.replace, props.keepTreeOnPush)

  React.useEffect(() => {
    mount()
  }, [])

  return null
}

MountSmartviewWithModel.defaultProps = {
  model: null,
  smartview: null,
  replace: true,
  keepTreeOnPush: false
}

MountSmartviewWithModel.propTypes = {
  model: PropTypes.any,
  smartview: PropTypes.node,
  replace: PropTypes.bool,
  keepTreeOnPush: PropTypes.bool
}

export default MountSmartviewWithModel
